import { Button, Typography, Box, Stack, Card, CardContent } from '@mui/material'
import { ReactComponent as Mail } from '@assets/images/icon/ico_mail.svg'
import { ReactComponent as Phone } from '@assets/images/icon/ico_phone.svg'
import { useIsMobile } from '@/hooks/Responsive'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function Inactivity() {
  const { isMobile } = useIsMobile()
  const lang = useLang() 
  const navigate = useNavigate()
  const location = useLocation();
  const { publicId } = location.state || {};

  // 휴대전화 본인인증으로 이동
  const nextPhone = () => {
    navigate(buildLangHref('/inactivity/phone', lang), {
      state: {
        publicId: publicId,
      },
    });
  }

  // 이메일 인증으로 이동
  const nextEmail = () => {
    navigate(buildLangHref('/inactivity/email', lang), {
      state: {
        publicId: publicId,
      },
    });
  }

  return (
    <Box>
      <Typography component="h3" variant={isMobile ? 'h6' : 'h5'} sx={{ mb: 1.5 }}>
        휴면계정안내
      </Typography>
      <Typography component="p" variant={isMobile ? 'body1' : 'subtitle2'} fontWeight={400} sx={{ mb: isMobile ? 4 : 6 }}>
        회원님의 계정이 6개월 이상 장기 미접속으로 비활성화되었습니다.<br /> 
        아래 본인 인증을 완료하시면, 즉시 서비스를 다시 이용하실 수 있습니다.
      </Typography>

      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={3}
        sx={{ mb: 1.5 }}
      >

        {/* 휴대전화 인증 */}
        <Card
          variant="outlined"
          sx={{
            flex: 1,
            borderRadius: 3,
          }}
        >
          <CardContent
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 3,
              minHeight: '136px',
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Box component={Phone} />
              <Typography variant="subtitle2" fontWeight={500}>
                휴대전화 인증
              </Typography>
            </Stack>

            <Button
              variant="contained"
              color="primary"
              onClick={nextPhone}
            >
              선택
            </Button>
          </CardContent>
        </Card>

        {/* 이메일 인증 */}
        <Card
          variant="outlined"
          sx={{
            flex: 1,
            borderRadius: 3,
          }}
        >
          <CardContent
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              minHeight: '136px',
              p: 3,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Box component={Mail} />
              <Typography variant="subtitle2" fontWeight={500}>
                이메일 인증
              </Typography>
            </Stack>

            <Button
              variant="contained"
              color="primary"
              onClick={nextEmail}
            >
              선택
            </Button>
          </CardContent>
        </Card>

      </Stack>
    </Box>
  )
}